class CarSelector extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    this.data = window.CAR_DATA || {};

    this.shadowRoot.innerHTML = `
  <style>
    .car-selector-wrapper {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 24px; /* 👈 left & right padding */
    }
    .row {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 12px;
    }

    select {
      width: 100%;
      padding: 12px;
      font-size: 14px;
    }

    @media (max-width: 768px) {
      .row {
        grid-template-columns: 1fr;
      }
    }
  </style>

  <div class="row">
    <select id="year">
      <option value="">Year</option>
    </select>

    <select id="make" disabled>
      <option value="">Make</option>
    </select>

    <select id="model" disabled>
      <option value="">Model</option>
    </select>
  </div>
`;

  }

  connectedCallback() {
    this.year = this.shadowRoot.querySelector('#year');
    this.make = this.shadowRoot.querySelector('#make');
    this.model = this.shadowRoot.querySelector('#model');

    this.populateYears();
    this.bindEvents();
  }

  populateYears() {
    Object.keys(this.data).forEach(year => {
      this.year.innerHTML += `<option value="${year}">${year}</option>`;
    });
  }

  bindEvents() {
    this.year.addEventListener('change', () => {
      this.reset(this.make, 'Select Make');
      this.reset(this.model, 'Select Model');

      if (!this.year.value) return;

      Object.keys(this.data[this.year.value]).forEach(make => {
        this.make.innerHTML += `<option value="${make}">${make}</option>`;
      });

      this.make.disabled = false;
    });

    this.make.addEventListener('change', () => {
      this.reset(this.model, 'Select Model');

      if (!this.make.value) return;

      this.data[this.year.value][this.make.value].forEach(model => {
        this.model.innerHTML += `<option value="${model}">${model}</option>`;
      });

      this.model.disabled = false;

      this.dispatchEvent(new CustomEvent('car-selected', {
        detail: {
          year: this.year.value,
          make: this.make.value,
          model: this.model.value
        }
      }));
    });
  }

  reset(select, label) {
    select.innerHTML = `<option value="">${label}</option>`;
    select.disabled = true;
  }
}

customElements.define('car-selector', CarSelector);
